
export class TrainingAnswer {
  id: number;
  order: number;
  text: string;
  correct: boolean;

  public deserialize(input: any): this {

    this.id = input.id;
    this.order = input.id;
    this.text = input.answer;
    this.correct = input.correct;

    return this;
  }

  static sort(a: TrainingAnswer, b: TrainingAnswer) : number {
    return a.id - b.id;
  }
}

